import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_j4dyen6dfe: FaireBrandEntity = {
  token: "b_j4dyen6dfe",
  type: "brand",
  name: "Remnant House Home Goods",
  avatarUrl:
    "https://cdn.faire.com/fastly/808837823643acde6eadab35350561b6059de1999a3f727d8a4fc2e06c13abc2.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/2a0cae97ccf5ec4e64c2364dbd7cb6680f978d64344dd01faba7efce62e7b0fe.png",
  logoUrl:
    "https://cdn.faire.com/fastly/808837823643acde6eadab35350561b6059de1999a3f727d8a4fc2e06c13abc2.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2a0cae97ccf5ec4e64c2364dbd7cb6680f978d64344dd01faba7efce62e7b0fe.png",
  location: "Sarasota, FL, USA",
  minimumOrderDollars: 100,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "At Remnant House Home Goods, we create faith-filled products that surround children with God’s truth from the very start. Our Scripture Sheets speak peace, break fear, and affirm identity, while our teething rings place the Word of God right in their mouths from infancy. Every piece is a daily reminder that your child is loved, chosen, and covered in God’s promises.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:05.094Z",
    importedBy: "entity-db-cli",
  },
};
